/* Little Bees v9 */
(function () {
  'use strict';
  var cfg = window.lb9 || {};
  var routes = cfg.routes || {};
  var root = routes.root || '/';
  var strings = cfg.strings || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  function store(key, value) {
    try {
      if (value === undefined) return window.localStorage.getItem(key);
      window.localStorage.setItem(key, value);
    } catch (e) { return null; }
    return null;
  }

  /* Money */
  function formatMoney(cents) {
    var format = cfg.moneyFormat || 'R {{amount}}';
    var value = (Number(cents) || 0) / 100;
    function withDelimiters(num, decimals, thousands, decimal) {
      var parts = num.toFixed(decimals).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
      return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals': return withDelimiters(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelimiters(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelimiters(value, 0, '.', ',');
        case 'amount_with_space_separator': return withDelimiters(value, 2, ' ', ',');
        default: return withDelimiters(value, 2, ',', '.');
      }
    });
  }

  function toast(message) {
    var el = document.createElement('div');
    el.className = 'lb9-toast';
    el.setAttribute('role', 'status');
    el.textContent = message;
    document.body.appendChild(el);
    setTimeout(function () { el.remove(); }, 3500);
  }

  function updateCounts(count) {
    $$('[data-lb9-count], .cart-badge').forEach(function (el) { el.textContent = count; });
  }

  function refreshDates() {
    if (typeof window.hiveArrival === 'function') window.hiveArrival();
    arriveBy();
  }

  /* Announcement: rotate on phones */
  (function () {
    var items = $$('[data-lb9-ann] li');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.matchMedia('(min-width: 750px)').matches) return;
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4500);
  })();

  /* Generic slide-in panels (menu + drawer) */
  var lastFocus = null;
  function openPanel(panel, opener) {
    if (!panel) return;
    lastFocus = opener || document.activeElement;
    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lb9-lock');
    var focusTarget = panel.querySelector('[data-lb9-menu-close]:not(.lb9-scrim), [data-lb9-drawer-close]:not(.lb9-scrim)');
    if (focusTarget) setTimeout(function () { focusTarget.focus(); }, 50);
  }
  function closePanel(panel) {
    if (!panel || !panel.classList.contains('is-open')) return;
    panel.classList.remove('is-open', 'is-added');
    panel.setAttribute('aria-hidden', 'true');
    if (!$('.lb9-menu.is-open, .lb9-drawer.is-open')) document.documentElement.classList.remove('lb9-lock');
    $$('[data-lb9-menu-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    var opener = t.closest('[data-lb9-menu-open]');
    if (opener) { opener.setAttribute('aria-expanded', 'true'); openPanel($('[data-lb9-menu]'), opener); return; }
    if (t.closest('[data-lb9-menu-close]')) { closePanel($('[data-lb9-menu]')); return; }
    if (t.closest('[data-lb9-menu] .lb9-menu__links a')) { closePanel($('[data-lb9-menu]')); return; }
    if (t.closest('[data-lb9-drawer-close]')) { closePanel($('[data-lb9-drawer]')); return; }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    closePanel($('[data-lb9-drawer]'));
    closePanel($('[data-lb9-menu]'));
  });

  /* Footer accordions on phones */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lb9-foot-toggle]');
    if (!btn || window.matchMedia('(min-width: 750px)').matches) return;
    var col = btn.closest('[data-lb9-foot]');
    var open = !col.classList.contains('is-open');
    col.classList.toggle('is-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    var sign = btn.querySelector('span');
    if (sign) sign.textContent = open ? '−' : '+';
  });

  /* Our story: read more on phones */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lb9-story-toggle]');
    if (!btn) return;
    var story = btn.closest('[data-lb9-story]');
    var collapsed = story.classList.toggle('is-collapsed');
    btn.setAttribute('aria-expanded', collapsed ? 'false' : 'true');
    btn.textContent = collapsed ? btn.dataset.more : btn.dataset.less;
  });

  /* Age picker */
  function pickStage(section, id, remember) {
    var found = false;
    $$('[data-lb9-stage-btn]', section).forEach(function (b) {
      var on = b.getAttribute('data-lb9-stage-btn') === id;
      if (on) found = true;
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
    if (!found) return;
    $$('[data-lb9-stage]', section).forEach(function (p) { p.hidden = p.getAttribute('data-lb9-stage') !== id; });
    if (remember) store('lb9-stage', id);
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lb9-stage-btn]');
    if (!btn) return;
    pickStage(btn.closest('[data-lb9-stages]'), btn.getAttribute('data-lb9-stage-btn'), true);
  });
  $$('[data-lb9-stages]').forEach(function (section) {
    var saved = store('lb9-stage');
    if (saved) pickStage(section, saved, false);
  });

  /* "Arrives by" bubble */
  function arriveBy() {
    $$('[data-lb9-arrive-by]').forEach(function (el) {
      if (typeof window.hiveBusinessDate !== 'function') return;
      var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Africa/Johannesburg', year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(new Date());
      var get = function (type) { return Number(parts.find(function (p) { return p.type === type; }).value); };
      var today = new Date(Date.UTC(get('year'), get('month') - 1, get('day')));
      var date = window.hiveBusinessDate(today, cfg.deliveryMax || 11);
      el.textContent = (el.dataset.prefix || '') + ' ' + new Intl.DateTimeFormat('en-ZA', { timeZone: 'UTC', weekday: 'short', day: 'numeric', month: 'short' }).format(date);
    });
  }
  arriveBy();

  /* Product card colour dots */
  document.addEventListener('click', function (e) {
    var dot = e.target.closest('[data-lb9-dot]');
    if (!dot) return;
    var card = dot.closest('[data-lb9-card]');
    $$('[data-lb9-dot]', card).forEach(function (d) { d.setAttribute('aria-pressed', d === dot ? 'true' : 'false'); });
    var idInput = $('[data-lb9-card-id]', card);
    if (idInput) idInput.value = dot.dataset.variantId;
    var img = $('.lb9-card__img', card);
    if (img && dot.dataset.img) { img.removeAttribute('srcset'); img.src = dot.dataset.img; }
    var price = $('[data-lb9-card-price]', card);
    if (price && dot.dataset.price) {
      price.innerHTML = '';
      var strong = document.createElement('strong'); strong.textContent = dot.dataset.price; price.appendChild(strong);
      if (dot.dataset.compare) { var s = document.createElement('s'); s.textContent = dot.dataset.compare; price.appendChild(s); }
    }
    var btn = $('[data-lb9-card-btn]', card);
    if (btn) {
      var available = dot.dataset.available === 'true';
      btn.disabled = !available;
      btn.textContent = available ? strings.quickAdd : strings.soldOut;
    }
  });

  /* Side bag */
  function renderDrawer(html) {
    var current = $('[data-lb9-drawer]');
    if (!html || !current) return current;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('[data-lb9-drawer]');
    if (!next) return current;
    var wasOpen = current.classList.contains('is-open');
    var wasAdded = current.classList.contains('is-added');
    current.replaceWith(next);
    if (wasOpen) { next.classList.add('is-open'); next.setAttribute('aria-hidden', 'false'); }
    if (wasAdded) next.classList.add('is-added');
    updateCounts(next.dataset.count);
    refreshDates();
    return next;
  }

  function showAdded(drawer, variantId) {
    if (!drawer) return;
    drawer.classList.add('is-added');
    var heading = $('[data-lb9-drawer-heading]', drawer);
    if (heading) heading.textContent = heading.dataset.added;
    var line = variantId && $('[data-lb9-line][data-variant-id="' + variantId + '"]', drawer);
    if (line) {
      line.classList.add('is-new');
      line.parentNode.insertBefore(line, line.parentNode.firstChild);
    }
    openPanel(drawer);
  }

  function sectionsUrl() { return window.location.pathname; }

  /* Make sure the bag belongs to the country we deliver to (stops "sold out" errors for overseas visitors) */
  function setCartCountry() {
    if (!cfg.country) return Promise.resolve();
    var fd = new FormData();
    fd.append('form_type', 'localization');
    fd.append('utf8', '✓');
    fd.append('_method', 'put');
    fd.append('country_code', cfg.country);
    fd.append('return_to', window.location.pathname);
    return fetch(root + 'localization', { method: 'POST', body: fd, credentials: 'same-origin' })
      .then(function () { store('lb9-country', cfg.country); })
      .catch(function () {});
  }
  function readJson(res) {
    return res.json().catch(function () { return {}; }).then(function (json) { return { ok: res.ok, json: json }; });
  }
  function isRegionError(json) {
    var text = String((json && (json.description || json.message)) || '');
    return /sold out|not available|unavailable/i.test(text);
  }
  function addToBag(makeRequest) {
    var ready = store('lb9-country') === cfg.country ? Promise.resolve() : setCartCountry();
    return ready
      .then(function () { return fetch(root + 'cart/add.js', makeRequest()).then(readJson); })
      .then(function (r) {
        if (r.ok || !isRegionError(r.json)) return r;
        return setCartCountry().then(function () { return fetch(root + 'cart/add.js', makeRequest()).then(readJson); });
      })
      .then(function (r) {
        if (r.ok) return r;
        if (isRegionError(r.json)) throw new Error(strings.deliveryRegion || r.json.description);
        throw new Error(r.json.description || r.json.message || strings.error);
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-lb9-add]');
    if (!form || cfg.cartType === 'page') return;
    e.preventDefault();
    var button = form.querySelector('[type="submit"]') || $('[form="' + form.id + '"][type="submit"]');
    var data = new FormData(form);
    data.append('sections', 'cart-drawer');
    data.append('sections_url', sectionsUrl());
    var variantId = data.get('id');
    form.classList.add('lb9-busy');
    $$('[data-lb9-submit]').forEach(function (b) { if (b.form === form) b.classList.add('lb9-busy'); });
    addToBag(function () { return { method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: data }; })
      .then(function (r) {
        var drawer = renderDrawer(r.json.sections && r.json.sections['cart-drawer']);
        showAdded(drawer, variantId);
      })
      .catch(function (err) { toast(err.message || strings.error); })
      .finally(function () {
        form.classList.remove('lb9-busy');
        $$('[data-lb9-submit]').forEach(function (b) { b.classList.remove('lb9-busy'); });
        if (button) button.blur();
      });
  });

  function changeLine(key, qty) {
    var drawer = $('[data-lb9-drawer]');
    if (drawer) drawer.classList.add('lb9-busy');
    return fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: Math.max(0, qty), sections: ['cart-drawer'], sections_url: sectionsUrl() })
    })
      .then(function (res) { return res.json().then(function (json) { return { ok: res.ok, json: json }; }); })
      .then(function (r) {
        if (!r.ok) throw new Error(r.json.description || strings.error);
        var next = renderDrawer(r.json.sections && r.json.sections['cart-drawer']);
        if (next) next.classList.remove('lb9-busy');
      })
      .catch(function (err) { toast(err.message || strings.error); if (drawer) drawer.classList.remove('lb9-busy'); });
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lb9-line-change]');
    if (!btn) return;
    changeLine(btn.getAttribute('data-lb9-line-change'), Number(btn.dataset.qty));
  });
  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-lb9-line-input]');
    if (!input) return;
    changeLine(input.getAttribute('data-lb9-line-input'), Number(input.value));
  });

  /* Quantity steppers on the product page */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lb9-qty]');
    if (!btn) return;
    var input = btn.parentNode.querySelector('[data-lb9-qty-input]');
    if (!input) return;
    input.value = Math.max(1, (Number(input.value) || 1) + Number(btn.getAttribute('data-lb9-qty')));
  });

  /* Product page: variant cards / select */
  function applyVariant(source) {
    var section = source.closest('[data-lb9-product]');
    if (!section) return;
    var d = source.dataset;
    var id = source.value;
    var idInput = $('[data-lb9-variant-id]', section);
    if (idInput) idInput.value = id;
    var price = $('[data-product-price]', section);
    if (price) {
      price.innerHTML = '';
      var cur = document.createElement('span'); cur.className = 'lb-current-price'; cur.textContent = d.price; price.appendChild(cur);
      if (d.compare) {
        var s = document.createElement('s'); s.className = 'lb-compare-price'; s.textContent = d.compare; price.appendChild(s);
        if (d.saving) { var b = document.createElement('span'); b.className = 'lb-save-badge'; b.textContent = d.saving; price.appendChild(b); }
      }
    }
    var available = d.available === 'true';
    $$('[data-lb9-submit]', section).forEach(function (b) { b.disabled = !available; b.textContent = available ? strings.add : strings.soldOut; });
    var stock = $('[data-lb9-stock]', section);
    if (stock) { stock.textContent = available ? stock.dataset.in : stock.dataset.out; stock.classList.toggle('is-out', !available); }
    var name = $('[data-lb9-current-name]', section); if (name) name.textContent = d.title;
    var sw = $('[data-lb9-current-swatch]', section); if (sw && d.swatch) sw.style.background = d.swatch;
    var stickyVariant = $('[data-lb9-sticky-variant]', section); if (stickyVariant) stickyVariant.textContent = d.title + ' · ';
    $$('[data-hive-sticky-price]', section).forEach(function (el) { el.textContent = d.price; });
    if (d.mediaId) {
      var thumb = $('[data-gallery-thumb][data-media-id="' + d.mediaId + '"]', section);
      if (thumb) thumb.click();
    }
    try {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', id);
      window.history.replaceState({}, '', url);
    } catch (err) { /* ignore */ }
  }
  document.addEventListener('change', function (e) {
    var radio = e.target.closest('[data-lb9-variant]');
    if (radio) { applyVariant(radio); return; }
    var select = e.target.closest('[data-lb9-variant-select]');
    if (select) {
      var opt = select.options[select.selectedIndex];
      var proxy = { value: opt.value, dataset: opt.dataset, closest: function (s) { return select.closest(s); } };
      applyVariant(proxy);
    }
  });
  (function () {
    var checked = $('[data-lb9-variant]:checked');
    if (checked && checked.dataset.mediaId) {
      var thumb = $('[data-gallery-thumb][data-media-id="' + checked.dataset.mediaId + '"]');
      if (thumb && !thumb.classList.contains('is-active')) thumb.click();
    }
  })();

  /* Sticky add bar */
  (function () {
    var sticky = $('[data-lb9-sticky]');
    var main = $('.lb9-product-form [data-lb9-submit]');
    if (!sticky || !main || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      var entry = entries[0];
      var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      sticky.classList.toggle('is-visible', past);
      sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
      $$('button', sticky).forEach(function (b) { b.tabIndex = past ? 0 : -1; });
    });
    io.observe(main);
  })();

  /* Bag page */
  document.addEventListener('click', function (e) {
    var step = e.target.closest('[data-lb9-step]');
    var remove = e.target.closest('[data-lb9-remove]');
    var key = step ? step.getAttribute('data-lb9-step') : remove ? remove.getAttribute('data-lb9-remove') : null;
    if (!key) return;
    var input = $('[data-line-key="' + (window.CSS && CSS.escape ? CSS.escape(key) : key) + '"]');
    if (!input) return;
    input.value = remove ? 0 : Math.max(0, (Number(input.value) || 0) + Number(step.dataset.delta));
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  function cartUpdate(payload) {
    return fetch(root + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(payload) });
  }
  document.addEventListener('change', function (e) {
    var gift = e.target.closest('[data-lb9-gift]');
    if (!gift) return;
    var wrap = $('[data-lb9-gift-note-wrap]');
    if (wrap) wrap.hidden = !gift.checked;
    cartUpdate({ attributes: { 'Gift wrap': gift.checked ? 'Yes' : '' } });
  });
  var noteTimer;
  document.addEventListener('input', function (e) {
    var note = e.target.closest('[data-lb9-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () { cartUpdate({ note: note.value }); }, 600);
  });
  document.addEventListener('click', function (e) {
    var apply = e.target.closest('[data-lb9-code-apply]');
    if (!apply) return;
    var input = $('[data-lb9-code]');
    var code = input && input.value.trim();
    if (!code) { if (input) input.focus(); return; }
    window.location.href = root + 'discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(routes.cart || '/cart');
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && e.target.matches('[data-lb9-code]')) {
      e.preventDefault();
      var btn = $('[data-lb9-code-apply]'); if (btn) btn.click();
    }
  });

  /* Gift box builder */
  $$('[data-lb9-builder]').forEach(function (builder) {
    var min = Number(builder.dataset.min) || 3;
    var savingPct = Number(builder.dataset.saving) || 0;
    var threshold = Number(builder.dataset.threshold) || 100000;
    var addBtn = $('[data-lb9-builder-add]', builder);
    var noteEl = $('[data-lb9-gift-note]', builder);
    var noteLeft = $('[data-lb9-note-left]', builder);
    var preview = $('[data-lb9-note-preview]', builder);
    var boxview = $('[data-lb9-boxview]', builder);
    var status = $('[data-lb9-builder-status]', builder);

    function variantFor(wrap) { return $('[data-lb9-pick-variant]', wrap); }
    function selectedData(wrap) {
      var v = variantFor(wrap);
      if (!v) return null;
      if (v.tagName === 'SELECT') { var o = v.options[v.selectedIndex]; return { id: o.value, price: Number(o.dataset.price), img: o.dataset.img }; }
      return { id: v.value, price: Number(v.dataset.price), img: v.dataset.img };
    }
    function picked() {
      return $$('[data-lb9-pick-wrap]', builder).filter(function (w) {
        return $('[data-lb9-pick]', w).getAttribute('aria-pressed') === 'true';
      });
    }
    function wrapChoice() { return $('[data-lb9-wrap]:checked', builder); }

    function render() {
      var chosen = picked();
      var n = chosen.length;
      var sub = 0;
      $$('img[data-lb9-box-img]', boxview).forEach(function (i) { i.remove(); });
      chosen.forEach(function (w) {
        var d = selectedData(w);
        if (!d) return;
        sub += d.price;
        if (d.img) {
          var img = document.createElement('img');
          img.src = d.img; img.alt = ''; img.setAttribute('data-lb9-box-img', '');
          boxview.appendChild(img);
        }
      });
      var empty = $('[data-lb9-box-empty]', boxview); if (empty) empty.hidden = n > 0;
      var ready = n >= min;
      var saving = ready && savingPct ? Math.round(sub * savingPct / 100) : 0;
      var countLabel = $('[data-lb9-count-label]', builder);
      if (countLabel) countLabel.textContent = n + ' ' + (n === 1 ? countLabel.dataset.one : countLabel.dataset.many);
      var subEl = $('[data-lb9-subtotal]', builder); if (subEl) subEl.textContent = formatMoney(sub);
      var savEl = $('[data-lb9-saving]', builder);
      if (savEl) savEl.textContent = ready ? '−' + formatMoney(saving) : savEl.dataset.locked.replace('[count]', min - n);
      var totEl = $('[data-lb9-total]', builder); if (totEl) totEl.textContent = formatMoney(sub - saving);
      addBtn.disabled = !ready;
      addBtn.textContent = ready ? builder.dataset.addLabel : builder.dataset.moreLabel.replace('[count]', min - n);
      var s1 = $('[data-lb9-step-1]', builder), s2 = $('[data-lb9-step-2]', builder), s3 = $('[data-lb9-step-3]', builder);
      if (s1) s1.classList.toggle('is-done', ready);
      if (s2) s2.classList.toggle('is-done', ready && !!wrapChoice());
      if (s3) s3.classList.toggle('is-done', !!(noteEl && noteEl.value.trim()));
    }

    builder.addEventListener('click', function (e) {
      var pick = e.target.closest('[data-lb9-pick]');
      if (!pick) return;
      var on = pick.getAttribute('aria-pressed') !== 'true';
      pick.setAttribute('aria-pressed', on ? 'true' : 'false');
      var mark = $('.lb9-pick__check', pick); if (mark) mark.textContent = on ? '✓' : '+';
      render();
    });
    builder.addEventListener('change', function (e) {
      if (e.target.matches('[data-lb9-wrap]')) {
        var box = e.target.dataset.box, band = e.target.dataset.band;
        boxview.style.background = 'linear-gradient(90deg,' + box + ' 46%,' + band + ' 46%,' + band + ' 54%,' + box + ' 54%)';
      }
      render();
    });
    if (noteEl) noteEl.addEventListener('input', function () {
      if (noteLeft) noteLeft.textContent = (Number(noteEl.getAttribute('maxlength')) || 160) - noteEl.value.length;
      if (preview) preview.textContent = noteEl.value.trim() || preview.dataset.empty;
      render();
    });

    addBtn.addEventListener('click', function () {
      var chosen = picked();
      if (chosen.length < min) return;
      var boxId = 'Box ' + Math.random().toString(36).slice(2, 6).toUpperCase();
      var wrap = wrapChoice();
      var note = noteEl ? noteEl.value.trim() : '';
      var items = chosen.map(function (w, i) {
        var props = {};
        props[builder.dataset.labelBox] = boxId;
        props._gift_box = boxId;
        if (i === 0) {
          if (wrap) props[builder.dataset.labelWrap] = wrap.value;
          if (note) props[builder.dataset.labelNote] = note;
        }
        return { id: Number(selectedData(w).id), quantity: 1, properties: props };
      });
      addBtn.disabled = true;
      var payload = JSON.stringify({ items: items, sections: ['cart-drawer'], sections_url: sectionsUrl() });
      addToBag(function () { return { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: payload }; })
        .then(function (r) {
          return cartUpdate({ attributes: { 'Gift wrap': 'Yes' } }).then(function () { return r; });
        })
        .then(function (r) {
          if (status) status.textContent = strings.added;
          if (cfg.cartType === 'page') { window.location.href = routes.cart || '/cart'; return; }
          var drawer = renderDrawer(r.json.sections && r.json.sections['cart-drawer']);
          showAdded(drawer, null);
          $$('[data-lb9-pick][aria-pressed="true"]', builder).forEach(function (p) { p.setAttribute('aria-pressed', 'false'); var m = $('.lb9-pick__check', p); if (m) m.textContent = '+'; });
          if (noteEl) { noteEl.value = ''; noteEl.dispatchEvent(new Event('input')); }
          render();
        })
        .catch(function (err) { toast(err.message || strings.error); addBtn.disabled = false; });
    });
    render();
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function () { refreshDates(); });
})();
